import Root from "./badge.svelte"

enum Colors {
    RED,
    ORANGE,
    YELLOW,
    GREEN,
    BLUE,
    INDIGO,
    PURPLE,
    GRAY,
    PINK
}


export {Root, Root as Badge, Colors}
